module.exports = __webpack_public_path__ + "static/img/legend_dark.5a44721.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/legend_dark.png
// module id = HQJU
// module chunks = 94